import React from "react";
import ThreeDotsDropdownButton from "components/Common/ThreeDotsDropdownButton";

export const ManageUserDropdownButton = ({
  onSelectDropdownOption,
  user,
  ...buttonProps
}) => {
  const dropdownOptions = [{ label: "Remove user", value: "remove" }];
  const onSelectEvent = e => {
    onSelectDropdownOption(e, user);
  };

  return (
    <ThreeDotsDropdownButton
      dropdownOptions={dropdownOptions}
      handleOnSelect={onSelectEvent}
      {...buttonProps}
    />
  );
};
